import * as React from 'react';
import {StatelessComponent} from 'react';
import {AlertModal} from '../../alert-modal/alert-modal';
import {Text} from '../../text/text';

import './styles.sass';

export interface ISessionRunTestsAlertProps {
  isOpen: boolean;
  onClose: (confirmed?: boolean) => void;
}

export const SessionRunTestsAlert: StatelessComponent<ISessionRunTestsAlertProps>
  = ({isOpen, onClose}: ISessionRunTestsAlertProps) => (
    <AlertModal
      isOpen={isOpen}
      onClose={onClose}
      title={'Unlock Test Evaluation'}
      buttonText={'Got it!'}
    >
      <div className={'session-run-tests-alert'}>
        <Text>
          To enable test case evaluation in this session, the interviewee must approve it on their side
          when they're ready, by clicking the Run Tests button.
        </Text>

        <Text>
          Ask them to Run Tests when they're ready!
        </Text>
      </div>
    </AlertModal>
  );
